import { render, staticRenderFns } from "./InvestingSection.vue?vue&type=template&id=84541f1a&scoped=true&"
import script from "./InvestingSection.vue?vue&type=script&lang=js&"
export * from "./InvestingSection.vue?vue&type=script&lang=js&"
import style0 from "./InvestingSection.vue?vue&type=style&index=0&id=84541f1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84541f1a",
  null
  
)

export default component.exports